export function formatList(intlShape, ...[value, formatOptions]) {
  return intlShape.formatList(value, formatOptions);
}